import { TableCell, TableRow } from "@capacit-com/lara-law-shared-ui";
import { Skeleton } from "@capacit-com/lara-law-shared-ui";
import { CustomColumnDef } from "@/components/data-table/types/custom-column-def";
import { Legislation } from "@/models/legislation/Legislation";

interface LegislationTableRowSkeletonProps {
  columns: CustomColumnDef<Legislation>[];
}

export const LegislationTableRowSkeleton = ({
  columns,
}: LegislationTableRowSkeletonProps) => {
  return (
    <TableRow className="p-2 min-h-12">
      {columns.map((column, index) => {
        const columnId =
          ("accessorKey" in column && column.accessorKey) ||
          ("id" in column && column.id) ||
          index.toString();

        // First column (title) gets special treatment with two skeleton lines
        const isTitleColumn =
          ("accessorKey" in column && column.accessorKey === "title") ||
          index === 0;

        if (isTitleColumn) {
          return (
            <TableCell key={columnId} className="w-6/12">
              <div className="flex flex-col items-start">
                <Skeleton className="h-4 w-[80%] mb-1" />
                <Skeleton className="h-4 w-[50%]" />
              </div>
            </TableCell>
          );
        }

        // Default skeleton for other columns
        return (
          <TableCell key={columnId}>
            <div className="flex items-center">
              <Skeleton className="h-4 w-[75%]" />
            </div>
          </TableCell>
        );
      })}
    </TableRow>
  );
};
